export const utilityKeys = {
  all: ["utilities"] as const,
  details: () => [...utilityKeys.all, "detail"] as const,
  detail: (utility_code: string | undefined) =>
    [...utilityKeys.details(), utility_code] as const,
  billCycles: (utility_code: string | undefined) =>
    [...utilityKeys.detail(utility_code), "billCycles"] as const,
}
